module.exports = __webpack_public_path__ + "static/media/deploy_success.c84de44a.svg";